export const VALUE_PLACEHOLDER = '{V}';
export const CURRENCY_CODE_PLACEHOLDER = '{S}';
const getPrefixSpacedFormat = (symbol) => `${symbol} ${VALUE_PLACEHOLDER}`;
const getPrefixFormat = (symbol) => `${symbol}${VALUE_PLACEHOLDER}`;
const getSuffixSpacedFormat = (symbol) => `${VALUE_PLACEHOLDER} ${symbol}`;
export const defaultCurrencyFormatConfig = {
    decimalDigits: 2,
};
export const getCurrencyFormat = ({ suffix, spaced, symbol }) => {
    if (symbol) {
        if (suffix && spaced) {
            return getSuffixSpacedFormat(symbol);
        }
        else if (spaced) {
            return getPrefixSpacedFormat(symbol);
        }
        else {
            return getPrefixFormat(symbol);
        }
    }
    return `${CURRENCY_CODE_PLACEHOLDER} ${VALUE_PLACEHOLDER}`;
};
// TODO: compare decimalDigits information with back-end
export const currencyFormatConfig = {
    USD: { decimalDigits: 2, symbol: '$' },
    EUR: { decimalDigits: 2, symbol: '€' },
    GBP: { decimalDigits: 2, symbol: '£' },
    JPY: { decimalDigits: 0, symbol: '¥' },
    AUD: { decimalDigits: 2, symbol: '$' },
    BRL: { decimalDigits: 2, symbol: 'R$' },
    CAD: { decimalDigits: 2, symbol: '$' },
    DKK: { decimalDigits: 2, symbol: 'kr', suffix: true, spaced: true },
    HKD: { decimalDigits: 2, symbol: '$' },
    HUF: { decimalDigits: 2, symbol: 'Ft' },
    MYR: { decimalDigits: 2, symbol: 'RM' },
    MXN: { decimalDigits: 2, symbol: '$' },
    TWD: { decimalDigits: 0, symbol: 'NT$' },
    NZD: { decimalDigits: 2, symbol: '$' },
    NOK: { decimalDigits: 2, symbol: 'kr', suffix: true, spaced: true },
    SGD: { decimalDigits: 2, symbol: '$' },
    SEK: { decimalDigits: 2, symbol: 'kr', suffix: true, spaced: true },
    CHF: { decimalDigits: 2, symbol: 'CHF' },
    RUB: { decimalDigits: 2, symbol: 'руб.', spaced: true },
    ILS: { decimalDigits: 2, symbol: '₪' },
};
//# sourceMappingURL=currency-format-config.js.map